const config = {
  baseApi: process.env.REACT_APP_BASE_URL || "http://192.168.29.158:9094",
};

export default config;
